// @needs-native-review — best-effort translation
import type { Translations } from '../types';

export const vi: Translations = {
  'meta.gameTitle': 'Luminary',

  'howto.title': 'Cách Chơi',
  'howto.pieces.heading': 'Các mảnh',
  'howto.pieces.source': 'Nguồn',
  'howto.pieces.mirror': 'Gương',
  'howto.pieces.switch': 'Công tắc',
  'howto.pieces.exit': 'Lối ra',
  'howto.pieces.wall': 'Tường',
  'howto.controls.heading': 'Điều khiển',
  'howto.controls.clickSlot.line1': 'Bấm vào ô',
  'howto.controls.clickSlot.line2': 'đặt gương',
  'howto.controls.dragMirror.line1': 'Kéo gương',
  'howto.controls.dragMirror.line2': 'xoay',
  'howto.controls.rightClick.line1': 'Chuột phải',
  'howto.controls.rightClick.line2': 'gỡ gương',
  'howto.controls.hint': 'Lăn chuột: xoay tinh 1°.   Chạm gương: xoay 15°.',
  'howto.objective.line1': 'Thắp sáng mọi công tắc — khóa lối ra tự bật mở.',
  'howto.objective.line2': 'Sau đó bấm vào lối ra. Giải với ít gương nhất có thể.',

  'howtoColor.title': 'Màu & Lăng kính',
  'howtoColor.pieces.heading': 'Mảnh mới',
  'howtoColor.pieces.prism': 'Lăng kính',
  'howtoColor.pieces.redSwitch': 'Công tắc đỏ',
  'howtoColor.pieces.yellowSwitch': 'Công tắc vàng',
  'howtoColor.pieces.whiteSwitch': 'Công tắc trắng',
  'howtoColor.how.heading': 'Cách chúng hoạt động',
  'howtoColor.how.line1': 'Tia trắng mang đỏ, lục và lam cùng một lúc.',
  'howtoColor.how.line2': 'Lăng kính tách ánh sáng trắng thành ba tia màu theo ba cạnh của nó.',
  'howtoColor.how.line3': 'Bấm vào lăng kính đã đặt để xoay mặt nhận tia.',
  'howtoColor.switches.line1': 'Công tắc có chấm màu — đó là màu chúng cần.',
  'howtoColor.switches.line2': 'Công tắc vàng (chấm đỏ + lục) cần cả hai màu cùng đến.',
  'howtoColor.switches.line3': 'Công tắc trắng (cả ba) cần đỏ, lục VÀ lam cùng lúc.',

  'options.hints.label': 'Hiện góc gợi ý trong câu đố',
  'options.hints.help': 'Hiển thị góc giữa tia tới và tia phản xạ tại mỗi điểm phản xạ.',

  'level.01-intro.title': 'Chào Ánh Sáng',
  'level.02-two-mirrors.title': 'Hai Khúc Cua',
  'level.03-corner.title': 'Tường Chắn Đường',
  'level.04-two-targets.title': 'Hai Mục Tiêu',
  'level.05-tight.title': 'Chật',
  'level.06-hello-color.title': 'Chào Màu',
  'level.07-pick-a-side.title': 'Chọn Một Bên',
  'level.08-yellow.title': 'Vàng',
  'level.09-magenta.title': 'Hồng Sen',
  'level.10-spectrum.title': 'Quang Phổ',

  // PuzzleScene
  'puzzle.itemCounter': '{used}/{optimal}',
  'puzzle.hint.angleType.right': 'vuông',
  'puzzle.hint.angleType.acute': 'nhọn',
  'puzzle.hint.angleType.obtuse': 'tù',
  'puzzle.hint.label': '{angle}°\n{type}',
};
